import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, MessageCircle } from "lucide-react";
import { PageHero } from "../components/site/Common";
import { SeoExtras } from "../components/site/SeoExtras";
import { RelatedLinks } from "../components/site/RelatedLinks";
import { IMG, CONTACT } from "../mock";
import CONTENT from "../seo-content.json";

const btn = "inline-flex items-center gap-2 rounded-full bg-[#F7F3EA] text-[#183C35] px-7 py-3.5 font-semibold hover:bg-white transition-colors duration-200";

// Keyword landing pages (e.g. /corfu-taxi-service), content from seo-content.json.
const LandingPage = ({ path }) => {
  const l = CONTENT.landings[path];
  const [label, to] = l.cta;
  return (
    <div data-testid="landing-page">
      <PageHero image={IMG[l.img] || IMG.hero} eyebrow={l.eyebrow} title={l.h1} sub={l.text}>
        <div className="mt-6 sm:mt-8 flex flex-wrap gap-3">
          {to === "whatsapp"
            ? <a href={CONTACT.whatsapp} target="_blank" rel="noreferrer" className={btn} data-testid="landing-cta"><MessageCircle className="w-4 h-4" />{label}</a>
            : <Link to={to} className={btn} data-testid="landing-cta">{label}<ArrowRight className="w-4 h-4" /></Link>}
        </div>
      </PageHero>
      <SeoExtras path={path} page={`landing${path.replace(/\//g, "-")}`} />
      <RelatedLinks current="" />
    </div>
  );
};

export default LandingPage;
